import React from 'react';
import { Helmet } from 'react-helmet'; // update meta tags

// Add custom meta to every component
const CustomMetaData = ({title,image,description,child}) => {
  return(
    <Helmet>
      <title>
        {title}
      </title>
      {/* Title for social platforms and search engines */}
      <meta property="og:title" content={title} />
      <meta name="title" content={title} />

      {/* Description for social platforms and search engines */}
      <meta property="og:description" content={description} />
      <meta name="description" content={description} />

      {/* Image for social platforms and other services */}
      <meta property="og:image" content={image} />
      <meta name="image" content={image} />
  
      {/* URL for canonical link */}
      <meta property="og:url" content={window.location.href} />
      <meta name="url" content={window.location.href} />
      <link rel="canonical" href={window.location.href} />

      {/* Optional: Type for social platforms */}
      <meta property="og:type" content="website" />

      <link
        rel="icon"
        href={image}
        id="favicon"
        type="image/x-icon"
      />
      <link rel="apple-touch-icon" href={image} sizes="180x180" />

      {/* twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <script type="application/ld+json" defer async>
        {`
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "${title}",
            "url": "${window.location.href}",
            "logo": "${image}",
            "description": "${description}"
          }
        `}
      </script>
      {child}
    </Helmet>
  )
};

export default CustomMetaData;